import { myPropertyARI } from "./propertyARI";
import { runGHA } from "./google";
import { runTripadvisor,  } from "./tripadvisor";
import { runTrivago } from "./trivago";

type DeviceInfoType = {
  osName: string;
  browserVersion: string;
  deviceType: string;
  browserName: string;
  browserEngineName: string;
};

type LocationType = {
  countryCode: string;
  cityName: string;
};

type RunType = {
  trivago: boolean;
  tripadvisor: boolean;
  google: boolean;
};

type ConfigType = {
  propertyTicker: string;
  start: string;
  end: string;
  seniors: number;
  adults: number;
  teenagers: number;
  children: number;
  babies: number | null;
  guestAges: number[] | null;
  deviceInfo: DeviceInfoType;
  countryCode: string;
  cityName: string;
  currency: string;
};

type BodyPropertyARIType = {
  propertyTicker?: string;
  start: string;
  end: string;
  seniors: number;
  adults: number;
  teenagers: number;
  children: number;
  babies: number | null;
  propertyTickers: boolean | null;
  promoCodes: string[];
  inventoryTickersLikeFilter: boolean | null;
  inventoryTickersEqualFilter: boolean | null;
  guestAges: number[] | null;
  channel: boolean | null;
  ignoredConfiguration: false;
  deviceInfo: DeviceInfoType;
  totalAmount: number | null;
  reservationAmount: number | null;
  locationInfo: LocationType;
};

type urlsType = {
  URL_PROPERTY_ARI_FIRST: string
  URL_PROPERTY_ARI_SECOND: string
  URL_DISCREPANCIES_TRIVAGO: string
  URL_DISCREPANCIES_TRIPADVISOR: string
  URL_DISCREPANCIES_GOOGLE: string
}
export const searchDiscrepancies = async (
  config: ConfigType,
  run: RunType,
  tolerance: number,
  nameHasDiscrepancies: [],
  setNameHasDiscrepancies: Function,
  urls: urlsType
) => {  
  const URL_PROPERTY_ARI = `${urls.URL_PROPERTY_ARI_FIRST}${config.propertyTicker}${urls.URL_PROPERTY_ARI_SECOND}`;

  const BODY_PROPERTY_ARI: BodyPropertyARIType = {
    start: config.start,
    end: config.end,
    seniors: config.seniors,
    adults: config.adults,
    teenagers: config.teenagers,
    children: config.children,
    babies: config.babies,
    propertyTickers: null,
    promoCodes: [],
    inventoryTickersLikeFilter: null,
    inventoryTickersEqualFilter: null,
    guestAges: config.guestAges,
    channel: null,
    ignoredConfiguration: false,
    deviceInfo: config.deviceInfo,
    totalAmount: null,
    reservationAmount: null,
    locationInfo: {
      countryCode: config.countryCode,
      cityName: config.cityName,
    },
  };

  let resTrivago;
  let resTripadvisor;
  let bodyTrivago;
  let bodyGHA;
  let resGHA;
  let bodyTripadvisor;

  const { customDataPropertyARI: customPropertyARI, initialResultJson } = await myPropertyARI(
    config.propertyTicker,
    URL_PROPERTY_ARI,
    BODY_PROPERTY_ARI
  );

  if (run.trivago) {
    const paramRunTrivago = {
      config,
      customPropertyARI,
      tolerance,
      initialResultJson,
      nameHasDiscrepancies,
      setNameHasDiscrepancies,
      urlTrivago: urls.URL_DISCREPANCIES_TRIVAGO
    };
    const { runBodyTrivago, runResTrivago } = await runTrivago(paramRunTrivago);
    bodyTrivago = runBodyTrivago;
    resTrivago = runResTrivago;
  }

  if (run.tripadvisor) {
    const paramRunTripadvisor = {
      config,
      customPropertyARI,
      tolerance,
      initialResultJson,
      nameHasDiscrepancies,
      setNameHasDiscrepancies,
      urlTripadvisor: urls.URL_DISCREPANCIES_TRIPADVISOR,
    };
    const { RUN_BODY_TRIPADVISOR, runResTripadvisor } = await runTripadvisor(paramRunTripadvisor)
    bodyTripadvisor = RUN_BODY_TRIPADVISOR;
    resTripadvisor = runResTripadvisor;
  }

  if (run.google) {
    const paramRunGHA = {
      config,
      customPropertyARI,
      tolerance,
      initialResultJson,
      nameHasDiscrepancies,
      setNameHasDiscrepancies,
      urlGoogle: urls.URL_DISCREPANCIES_GOOGLE
    };
    const { runBodyGHA, runResGHA } = await runGHA(paramRunGHA)
    bodyGHA = runBodyGHA
    resGHA = runResGHA
  }

  return {
    initialResultJson,
    bodyPropertyAri: BODY_PROPERTY_ARI,
    restPropertyAri: customPropertyARI,
    bodyTrivago,
    resTrivago,
    bodyTripadvisor,
    resTripadvisor,
    bodyGHA,
    resGHA,
  };

};
